import React from "react";
import { ReactComponent as IconLogo } from "../components/Img/IconLogo.svg";

export const Navigation = (props) => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <a className="navbar-brand page-scroll" href="#page-top">
          <IconLogo
              className="iconLogo"
              sx={{ top: "3px",
                left: "30px",
                height: "70px" }}
            />
          </a>
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            {/*<li>
              <a href="#features" className="page-scroll">
                Features
              </a>
            </li>*/}
            
            <li>
              <a href="#services" className="page-scroll">
                Servicios
              </a>
            </li>
            <li>
              <a href="#about" className="page-scroll">
                Acerca de nosotros
              </a>
            </li>

            {/* <li>
              <a href="#portfolio" className="page-scroll">
                Gallery
              </a>
            </li>
             <li>
              <a href="#testimonials" className="page-scroll">
                Testimonials
              </a>
            </li>*/}
            <li>
              <a href="#team" className="page-scroll">
                Nuestros clientes
              </a>
            </li>
            <li>
              <a href="#contact" className="page-scroll">
                Contacto
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
